// @flow

// Vendors
import React from 'react';

// Components
import { Thumbnail } from '../../components';

// Helpers
import { swapUrlIfNeeded } from '../../../lib/helpers';

// Types
type Props = {
  project: {
    url: String,
    title: String,
    thumbnail: {
      src: String,
      alt: String
    }
  },
  hoverText: string
};

const ProjectsGridItem = ({
  project: { url, thumbnail, title },
  hoverText
}: Props) => (
  <a href={url} className="project-grid__item">
    <Thumbnail
      {...thumbnail}
      placeholderSize={{ width: 1280, height: 940 }}
      hoverText={hoverText}
    />
    <h3 className="project-grid__item__title">
      <span>{title}</span>
    </h3>
  </a>
);

ProjectsGridItem.defaultProps = {
  hoverText: 'View Project'
};

export default ProjectsGridItem;
